import { Grid, Box, Typography } from "@mui/material"
import Page from "components/Page"

const Privacy = () => {
  return (
    <Page id="privacy">
      <Grid container direction="column" alignItems="center" justifyContent="center"> 
        <Box m={5} pl={5} pr={5}></Box>
          <Typography pb={2} fontFamily="Ranade" fontSize={24}>
            Privacy Policy
          </Typography>
          <Typography fontFamily="General Sans" fontSize={16} maxWidth={800}>
            <i>Last updated: December 21, 2025</i>
            <Box p={1}></Box>
            We do not directly collect personal or identifying information from users, nor do we sell, share, 
            or otherwise disclose any user data. However, our website is hosted by <b>Vercel</b>, a third-party 
            service provider. When you visit the site, Vercel may automatically collect certain technical 
            information such as:
            <Box p={1}></Box>
            - IP address<br/>
            - Traffic to and from this website<br/>
            - Location information (derived from IP address)<br/>
            - System configuration details, such as browser type and operating system<br/>
            <Box p={1}></Box>
            This data is collected by Vercel for operational, performance, and security purposes. For more 
            information about how Vercel collects, retains, secures, and discloses information, please visit their
            <span>&nbsp;</span><a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noreferrer"><u>Privacy Policy</u></a>.
            <Box p={1}></Box>
            We also utilize <b>Vercel’s Web Analytics</b> to gain insights into how users interact with the website. 
            This tool collects anonymized data about your visit, such as the pages you view, your operating system, 
            browser, and general geographic location. Vercel’s Web Analytics does not use cookies and stores only 
            anonymized information to help us understand website performance and user behavior. For more details 
            please refer to<span>&nbsp;</span><a href="https://vercel.com/docs/analytics" target="_blank" rel="noreferrer"><u>Vercel’s Web Analytics documentation</u></a>.
            <Box p={1}></Box>
            This website is operated from the United States. By using this site, you acknowledge that your information 
            may be processed by third-party services in accordance with applicable data protection laws. Visitors from
            the European Union should be aware that third-party services used by this website (such as hosting 
            providers, content delivery networks, and font delivery services) may collect technical information, including IP addresses, which 
            may be classified as personal data under the <b>General Data Protection Regulation (GDPR)</b>.
            <Box p={1}></Box>
            We may update this privacy policy from time to time. Any changes will be posted on this page with an updated
            revision date. Please review this page periodically for updates. If you have any questions about this policy,
            you can reach us at<span>&nbsp;</span><a href="mailto:contact@randomwalk.online" target="_blank" rel="noreferrer">contact@randomwalk.online</a>.
          </Typography>
        <Box m={10} pb={5}></Box>
      </Grid>
    </Page>
  )
}

export default Privacy